<template>
  <div class="modal-request">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TheModalRequest'
}
</script>

<style lang="scss">
.modal-request{
  font-size: 1.4rem;

  .form-group{
    margin-bottom: 1.5rem;
  }

  label{
    margin-bottom: 0;
    font-size: 1.4rem;
    font-weight: font-weights("normal");
  }

  input{
    margin-bottom: 0;
    background-color: colors("foreground");
    border-color: colors("border");
    border-radius: 5px;
  }

  .button-submit{
    margin-right: .6rem;
  }

  .button-cancel{
    margin-left: .6rem;
    color: tint(black, 50%);
    font-weight: font-weights("bold");
  }
}
</style>
